import { IconButton, Input, Tooltip, Uploader, UploaderTitle } from "@evergis/ui";
import React, { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../../../../evergis/api";
import { isValidUrl } from "../../../../utils/isValidUrl";
import { UploaderTitleContainer, UploaderTitleDescription } from "./styled";
import { FileUploaderProps } from "./types";

export const FileUploader: FC<FileUploaderProps> = props => {
  const { t } = useTranslation("dialogs");

  const { showTitle = true, onFileUrlUpload } = props;
  const [url, setUrl] = useState<string>();

  const importFileURL = useCallback(async () => {
    if (isValidUrl(url)) {
      const fileInfo = await api.file.getFileInfo({ url });

      onFileUrlUpload({ ...fileInfo, url });
    }
  }, [url, onFileUrlUpload]);

  return (
    <Uploader
      doneText={t("uploadData.uploaded")}
      title={
        showTitle && (
          <UploaderTitleContainer>
            <UploaderTitle
              dropText={t("dropFiles", { ns: "common" })}
              selectText={t("selectFiles", { ns: "common" })}
            />
            <UploaderTitleContainer
              style={{ marginLeft: "2rem" }}
              onClick={event => {
                event.stopPropagation();
              }}
            >
              <UploaderTitleDescription>{t("import.orSpecifyUrl")}</UploaderTitleDescription>
              <Tooltip content={t("import.fileUrlRequirement")} placement="top" arrow delay={0.5}>
                {ref => <IconButton style={{ marginRight: "1rem" }} innerRef={ref} kind={"info"} />}
              </Tooltip>
              <Input
                placeholder={"https://datasource.com/file_name"}
                width={"17rem"}
                value={url}
                onChange={event => setUrl(event.target.value)}
              >
                <IconButton kind={"arrow_forward"} onClick={importFileURL} />
              </Input>
            </UploaderTitleContainer>
          </UploaderTitleContainer>
        )
      }
      {...props}
    />
  );
};
